import { useScopedAppFlagStore } from '@frontend/scope';

export const useShowAppointmentAnalyticsV2 = (): boolean => {
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const showAppointmentAnalyticsV2 = getFeatureFlagValue('show-appointment-analytics-v2');
  return showAppointmentAnalyticsV2;
};
